import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
import { DialogWindowState } from '../../store/schema/DialogWindowState';

export let toggleConnectGmailWindow = mutatorAction(
    'toggleConnectGmailWindow',
    (state: DialogWindowState) => {
        let store = connectedAccountsStore();
        store.dialogWindowState.connectGmailOpen = state.connectGmailOpen;
    }
);
